<template>
  <base-section id="404">
    <base-heading title="404" />

    <base-subheading
      class="primary--text"
      :title="$t('notFound.exclamation')"
    />

    <base-subheading
      space="8"
      :title="$t('notFound.message')"
    />

    <div class="text-center">
      <base-btn :to="{ name: 'Home', params: { lang: $i18n.locale } }">
        {{ $t('notFound.cta') }}
      </base-btn>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'FourOhFour',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
